import "../../../common/js/3rdparty/date.js";

import $ from "webpack-zepto";
window.$ = $;

import Ajax from "../../../common/js/Ajax.js";
import Navigation from "../../../common/js/Navigation.js";
import SelectableTableRow from "../../../common/js/SelectableTableRow.js";
import WidgetLoader from "../../../common/js/WidgetLoader.js";
import ZoomImage from "../../../common/js/image/ZoomImage.js";

import ActivationWidget from "./activation/ActivationWidget.js";
import FreeLicenseWidget from "./admin/order/FreeLicenseWidget.js";
import LoginWidget from "./admin/LoginWidget.js";
import LogoutWidget from "./admin/LogoutWidget.js";
import OrdersWidget from "./admin/order/OrdersWidget.js";
import OrderWidget from "./admin/order/OrderWidget.js";

$(() => {
	Ajax.initialize();
	Navigation.initialize();
	SelectableTableRow.initialize();
	ZoomImage.initialize();

	WidgetLoader.add("ActivationWidget", ActivationWidget);
	WidgetLoader.add("FreeLicenseWidget", FreeLicenseWidget);
	WidgetLoader.add("LoginWidget", LoginWidget);
	WidgetLoader.add("LogoutWidget", LogoutWidget);
	WidgetLoader.add("OrdersWidget", OrdersWidget);
	WidgetLoader.add("OrderWidget", OrderWidget);

	WidgetLoader.initialize();
});
